import React from 'react';
import { useTranslation } from 'react-i18next';

const Error404 = () => {
	const { t } = useTranslation();

	return (
		<div id="error-container" className="error-container">
			<h1 className="code">
				4<span className="flip">0</span>4
			</h1>
			<h5 className="message">
				{t("THE PAGE DOESN'T EXIST OR IS UNAVAILABLE.")}
			</h5>
			<a className="link fz fz-home extra-large has-text-primary" href="/" />
		</div>
	);
};

export default Error404;
